import React, { useState, useEffect } from 'react';
import Slider from '../lib/slider';
import moment from 'moment';
import Info from '../lib/info';

const License = props => {

  const { dataprovider, staticel, is_dev, userinfo } = props;
  require('moment/locale/de');
  moment.locale('de');
  
  const [licenses, setLicenses] = useState([]);
  const [extend, setExtend] = useState(0);
  const [emails, setEmails] = useState({});
  const [actionRow, setActionRow] = useState(0);
  const [infoMsg, setInfoMsg] = useState(false);
  
  useEffect(() => {
    dataprovider.getList('license', {}, setLicenses);
  }, [dataprovider]);
  
  const handleChangeExtend = (ev) => {
    setExtend(ev.target.value);
  }
  const handleChangeEmail = (k) => (ev) => {
    const em = {...emails};
    em[k] = ev.target.value;
    setEmails(em);
  }

  const doReload = () => {
    window.location.reload();
  }
  const revokeLicense = (k, action) => (ev) => {
    dataprovider.del('license/'+licenses[k].id, {action:action}, doReload);
  }
  const delLicense = (k) => (ev) => {
    setActionRow(k);
  }
  const doneAssign = (data) => {
    if (data.error) {
      setInfoMsg(['Achtung',(<span><p>Dieser E-Mail Adresse ist bereits eine Lizenz zugeordnet.</p><p>Falls eine neue Lizenz zugeordnet werden soll, muss zuerst die bestehende Lizenz zurückgesetzt werden.</p></span>)]);
    }
    else {
      doReload();
    }
  }
  const assignLicense = (k) => (ev) => {
    dataprovider.update('license/'+licenses[k].id, {email:emails[k]}, doneAssign);
  }
  const leaveTeam = (ev) => {
    dataprovider.del('license', {action:'leaveTeam'}, doReload);
  }
  const toBasket = data => {
    window.location.hash = '#basket';
  }
  const addLicense = total => ev => {
    dataprovider.insert('basket/license', {extend:extend, total:total}, toBasket);
  }
  
  var firstExp = licenses.reduce((pv, cv) => { return cv.expiry < pv?cv.expiry:pv}, '9999-99-99');
  const isFlat = licenses.reduce((pv, cv) => { return cv.expiry==='2100-01-01'?true:pv}, false);

  console.log({isFlat})
  
  const months = [];
  for (var i = 1;i<=24;i++) {
    var d = moment().add(i, 'M');
    if (d.format('YYYY-MM-DD') > firstExp) {
      months.push({value:i, text:d.format('MMM YYYY')});
    }
  }
  
  const team = licenses.length > 1;
  
  const extmoemnt = moment().add(extend, 'M').startOf('month');
  var total = 0;
  const price = licenses.length > 1?3:4;
  const limited = userinfo.teamadmin!==userinfo.email;
  
  if (userinfo.license===-1 && userinfo.team<1) {
    return (
    <>
      <Slider staticel={staticel} page={10} is_dev={is_dev} />
      <div className="py-5 bg-light">
        <div className="container mt-2">
          <h1>Lizenzverwaltung</h1>
          <p>Du hast keine aktive Lizenz. Du kannst <a href="/app#shop/s114">hier</a> eine erwerben.</p>
        </div>
      </div>
    </>
    )
  }
  
  return (
    <>
      <Slider staticel={staticel} page={10} is_dev={is_dev} />
      <div className="py-5 bg-light">
        <div className="container mt-2">
          <h1>Lizenzverwaltung</h1>
    {(userinfo.teamadmin && (limited || licenses.length>1)) && 
          <h4>Teamadministrator: {userinfo.teamadmin}
            {!limited && isFlat?' - aktuell '+licenses.length+' Lizenzen':''}
          </h4>
    }          
          <div className="row p-3 align-items-center">
            <div className="col-3">E-Mail.</div>
            <div className="col">Gültig bis</div>
        {!limited &&
          <>
            <div className="col">{isFlat?'':'Verlängerung'}</div>
            <div className="col"></div>
            <div className="col"></div>
            <div className="col"></div>
          </>
        }
          </div>
      {licenses.map((el, k) => {
        var start = moment().startOf('month');
        if (el.expiry) {
          var lic = moment(el.expiry);
          if (lic < start.add(1, 'M')) {
            lic = start;
          }
        }
        var diff = 0;
        if (extend > 0) {
          diff = extmoemnt.diff(moment(lic), 'month') + 1;
          if (!el.id) {
            diff += 12;
            if (diff < 12) diff = 12; 
          }
          if (diff > 0) total += diff;
        }
        return (
          <div className="row mb-3 p-3 align-items-center" style={{backgroundColor:'#f2f2f2', borderRadius:'15px'}} key={el.id}>
            <div className="col-3">{el.email?el.email:<input type="email" className="form-control" value={emails[k]} onChange={handleChangeEmail(k)}/>}</div>
            <div className="col">{el.expiry==='2100-01-01'?'Pauschallizenz':(el.expiry?moment(el.expiry).subtract(1, 'd').format('MMM YYYY'):'-')}</div>
        {!limited &&
          <>
            <div className="col">{diff > 0?diff+' Monat'+(diff>1?'e':''):''}</div>
            <div className="col">
            {(el.email && licenses.length>1 && el.expiry!=='2100-01-01') && 
              <button type="button" className="btn btn-primary ms-2" onClick={revokeLicense(k, 'reset')}>Lizenz zurücksetzen</button>
            }
            </div>
            <div className="col">
            {(!el.email && licenses.length>1) &&
              <button type="button" className="btn btn-primary ms-2" onClick={assignLicense(k)}>Lizenz zuordnen</button>
            }
            </div>
            <div className="col">
            {(!el.email || isFlat) && 
              <button type="button" className="btn btn-primary ms-2" data-bs-toggle="modal" data-bs-target="#delLicense" onClick={delLicense(k)}>Lizenz löschen</button>
            }
            </div>
          </>
        }
          </div>
      )})}
      {!limited && !isFlat &&
          <>
            <div className="row mb-3 p-3 pt-0 align-items-center">
              <div className="col">{team &&<a href="/app#shop/s114"className="btn btn-primary" >Weitere Lizenzen hinzufügen</a>}</div>
              <div className="col"></div>
              <div className="col"></div>
              <div className="col"></div>
            </div>
            <span>{licenses.length > 1?'Alle Lizenzen':'Lizenz'}</span> verlängern bis 
            <select className="form-select d-inline w-auto ms-2" value={extend} onChange={handleChangeExtend}>
              <option value="0"></option>
            {months.map(m=>(
              <option value={m.value} key={m.value}>{m.text}</option>
            ))}
            </select>
            {total > 0 && <button type="button" className="btn btn-primary ms-2" onClick={addLicense(total)}>{total+' Monat'+(total>1?'e':'')} à CHF {price.toFixed(2)} = CHF {(price * total).toFixed(2)} in den Warenkorb</button>}
          </>
      }
      {limited && 
        <button type="button" className="btn btn-primary ms-2" data-bs-toggle="modal" data-bs-target="#leaveTeam">Team verlassen</button>
      }
        </div>
      </div>
      
      <div className="modal fade" id="delLicense" tabIndex="-1" aria-labelledby="delLicense" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Lizenz löschen</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              Mit dem Löschen der Lizenz verfällt die Restlaufzeit.
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Abbrechen</button>
              <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={revokeLicense(actionRow, 'cancel')}>Löschen</button>
            </div>
          </div>
        </div>
      </div>      
      <div className="modal fade" id="leaveTeam" tabIndex="-1" aria-labelledby="leaveTeam" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Team verlassen</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
               Du verlässt hiermit das Team von {userinfo.teamadmin}.<br/> <br/> 
               Du kannst danach eine Einzellizenz erwerben oder einem anderen Team beitreten.<br/><br/>
               Dabei bleiben alle deine Daten erhalten.
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Abbrechen</button>
              <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={leaveTeam}>Team verlassen</button>
            </div>
          </div>
        </div>
      </div>      
      <Info msg={infoMsg} setMsg={setInfoMsg} />
    </>
  )
}

export default License;
